























































import { Component, Vue, Prop } from 'vue-property-decorator'
import  NoData from '@/components/NoData'
const echarts = require('echarts')
@Component({
  name: 'Tenthousandtow',
  components: {NoData },
 filters:{
   dateFilter: (value: string) => {
     if(!value){
       return 
     }
   
     return value.toString().indexOf('-') > -1? (value.split('-')[0]+'年'+value.split('-')[1]+'月'): (value+'年')
   }
 }
})
export default class Tenthousandtow extends Vue {
  @Prop() data: any
  @Prop() index: any
  @Prop() DateObj: any
  private init() {
    const echartsData: any = []
     if( this.data.outputList.length==0){
      return
    }
    this.data.outputList.forEach((item: any) => {
      echartsData.push([item.month, Number(item.dataValue)])
    })
    const main = document.getElementById('Tenthousandtowtow')
    // 基于准备好的dom，初始化echarts实例
    const myChart: any = echarts.init(main as HTMLDivElement)
    // 指定图表的配置项和数据
    const option = {
      color: ['#44f0ff'],
      textStyle: {
        color: '#999999',
      },
      tooltip: {},
      grid: {
        top: '6%',
        left: '0',
        // right: '2%',
        bottom: '3%',
        containLabel: true,
      },
      yAxis: {
        type: 'value',
        show: true,
        name: '等级告警趋势线图',
        nameLocation: 'end',
        nameGap: 40,
        nameTextStyle: {
          color: '#999999',
          fontSize: 16,
          padding: [0, 0, 0, 74],
        },
        axisLabel: {
          color: '#999999',
          fontSize: 12,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#efefff',
          },
        },
        axisTick: {
          show: true,
          lineStyle: {
            color: '#efefff',
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#efefff',
          },
        },
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          color: '#999999',
          fontSize: 12,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#efefff',
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: '#0b4377',
          },
        },
      },
      series: [
        {
          name: '万元工业增加值能耗',
          type: 'line',
          smooth: true,
          areaStyle:{
            normal:{
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0.6,
                    color: '#44f0ff'
                }, {
                    offset: 0.8,
                    color: '#ffffff'
                }]),
                opacity:0.9
                }
            },
          data: echartsData,
        },
      ],
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option)
  }
  ReloadFun(){
    setTimeout(() => {
      this.init()
    }, 0)
  }
  textType(text:any){
      if(text == null) return '-'
      if(text > 0 ) return '+'+text
      if(text < 0 ) return text
      if(text == 0) return text
  }
  colorType(text:any){
      if(text > 0 ) return 'negative'
      if(text < 0 ) return 'positive'
      if(text == 0) return ''
  }
  created() {
    setTimeout(() => {
      this.init()
    }, 0)
  }
}
